export { default } from './AccommodationIndex';
